import state from './state';
import getters from './getters';
import mutations from './mutations';
import actions from './actions';

import {
	mapGetters
} from 'vuex';

export default {
	state,
	getters,
	mutations,
	actions,
	name: 'breadcrumb',
	computed: {
		...mapGetters({
			pages: 'breadcrumbPages'
		})
	}
};



// WEBPACK FOOTER //
// ./sources/components/breadcrumb/index.js